<template>

    <v-row>
    <v-col xs="12">
      <v-form  ref="form" lazy-validation>
           <div class="grey lighten-3 pa-3 text-center">
      <v-card>
      <v-img :src="$store.state.config.BackgroundImageUrl" />
     <!-- <v-overlay
          :absolute="true"
          :opacity="0.5"
          :value="true"
        >
          <img :src="$store.state.config.LogoImageUrl" 
          class="shrink mr-2"
          contain
          aspect-ratio="5"
          transition="scale-transition">
        </v-overlay>
        -->
      </v-card>
      
   
           
           
        </div>
        <v-col cols="12" class="text-center">
            <v-col class="display-2"><center>{{$store.state.config.HotelName}}</center></v-col>
            <v-col class="headline" ><center><span v-html="$store.state.labels.WelcomeText"></span></center></v-col>
                  
                  <v-col > 
                        <v-row class="grey lighten-3 mt-2"> 
                        <v-col xs ="1"></v-col> 
                             <v-col cols ="10">
                                <center><span v-html="$store.state.labels.PrivacyText"></span></center>  
                            </v-col>      
                            <v-col xs ="1"></v-col>                   
                        </v-row> 
                  </v-col>

          </v-col>
        
          <v-col cols="12" align="center" justify="center"> 
            
              <v-row v-for="(consenso) in consensiprivacy" :key="consenso.IdFinalita" align="center" justify="center">
                
                <v-col cols="8" >
                  <v-card  >
                  
                    
                      <v-switch  
                            class="mx-2"
                            :label=consenso.Descrizione
                            v-model="consenso.accettato"
                            :rules="[v => (!!v || consenso.ConsensoNecessario==0) || 'Devi accettare prima di procedere!']"
                                                   
                            >
                      </v-switch >
                      
                    </v-card>
                </v-col>
                
              </v-row>
              
          </v-col>
        

        <v-col cols="12" class="text-center">
         <v-btn round dark large @click="submit" color="green">{{labels.welcome_inizia}}</v-btn>
        </v-col>
        <!--<v-btn round dark large @click="cambiacolori()" color="primary">cambia colore</v-btn>-->
        </v-form>
        </v-col>
        </v-row>

</template>

<script>
  export default {
    data() {

       return {
               idprenotazione:"", 
               checkbox: false,
                titolo:"Salve Mario, benvenuto nella nostra area riservata.",
            
                testo:"Compila i dati di tutti gli ospiti della prenotazione che troverai suddivisi per camera. \
                        Una volta completato l'inserimento clicca sul bottone verde 'salva e invia' e la procedura sarà terminata.\
                         Puoi comunque tornare e modificare i dati immessi fino a 2 giorni prima del tuo arrivo.<br>\
                        Per iniziare il check-in online premi sul pulsante qui sotto.<br> \
                        Ci vediamo presto!",
                welcomeimage:"http://www.evoluteehotel.com/uploads/images/home/home_10_2015.jpg",
                hotelname:"Hotel Demo",
                consensiprivacy:[]
       };
    },
    props: ['texts'],
    computed: {
      labels(){
        return this.$store.state.labels;
      }
    },
    created(){
        this.$store.watch(
          // eslint-disable-next-line no-unused-vars
          (state)=>{
            return this.$store.state.currentlan // could also put a Getter here
          },
          (newValue, oldValue)=>{
            //something changed do something
            console.log(oldValue)
            console.log(newValue)
            this.consensiprivacy=[];
            for (const key in this.$store.getters.privacyfinalita) {
                const element = this.$store.getters.privacyfinalita[key];
                this.consensiprivacy.push(element);
            }
          },
        //Optional Deep if you need it
            {
              deep:true
            }
          )
    },
    mounted: function() {
      console.log("HOMEPAGEMOUNTED")
      var itemId = this.$route.params.reservationid;
      if(!itemId){
        itemId = this.$store.getters.reservationid;
      }
      
      var apiurl = this.$store.state.settings.apiurl;
      console.log("caricoprenotazioneXXX", itemId,apiurl);
      if(itemId){
        this.setReservationid(apiurl, itemId).then(r=>{
            console.log("fine caricamento prenotazione",r);
            this.loadcomuni();
        });
      }

      
    },
    
    methods: {
      loadcomuni(){
        console.log("CARICO COMUNI 2")
          this.$store.dispatch("UpdateComuniFromHR")          
          // eslint-disable-next-line no-unused-vars
          .then(r=>{
              //console.log(r);
          })
        // eslint-disable-next-line no-unused-vars
        .catch(r=>{
              //console.log(r);
          });
        },
      cambiacolori(){
        console.log("applica colore")
        this.$vuetify.theme.isDark = false
        this.$vuetify.theme.themes.light.primary = this.$store.state.config.ThemeColor
      },
      submit () {
          if (this.$refs.form.validate()) {
              // eslint-disable-next-line no-unused-vars
              this.$store.dispatch("setprivacy", this.consensiprivacy).then(c=>{


              
              if(this.$store.state.reservation.config.ConfermaNumeroOspiti &&  this.$store.state.reservation.config.ConfermaNumeroOspiti == 1){
                //window.location.href = "#/nguest/"+this.idprenotazione
                this.$router.push({ path: `/nguest/${this.idprenotazione}` })
              }else{
                //window.location.href = "#/precheckin/"+this.idprenotazione
                this.$router.push({ path: `/precheckin/${this.idprenotazione}` })
              }
              
              });

              // ;

          }
        },
      setReservationid(apiurl, id) {
        this.idprenotazione = id

         return this.$store.dispatch("setreservation", id).then(a=>{
            this.cambiacolori();  
            console.log(a);
            this.consensiprivacy=[];
            for (const key in this.$store.getters.privacyfinalita) {
                const element = this.$store.getters.privacyfinalita[key];
                this.consensiprivacy.push(element);
            }         

         })
      }
  }
  };
</script>
